module.exports = __webpack_public_path__ + "static/media/icon-search.f6c694c9.svg";